<template>
  <div class="space-y-4 p-8">
    <h2 class="font-semibold uppercase text-gray-600 text-2xl">
      System Settings
    </h2>

    <form @submit.prevent="update">
      <div class="flex pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            Driver Settings
          </h3>
          <p class="text-gray-600">Set the settings related to drivers</p>
        </div>
        <div class="w-2/3">
          <div class="flex">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Request Timeout (in seconds)</span>
              <input
                v-model="settings.requestTimeout"
                class="form-input block w-full"
                placeholder="30"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Default Commission</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  %
                </span>
                <input
                type="number"
                min="0"
                  v-model="settings.defaultCommission"
                  class="form-input block w-full rounded-l-none"
                  placeholder="20"
                />
              </div>
            </label>
          </div>
          <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Default Road pickup Commission</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  %
                </span>
                <input
                type="number"
                min="0"
                  v-model="settings.defaultRoadPickupCommission"
                  class="form-input block w-full rounded-l-none"
                  placeholder="20"
                />
              </div>
            </label>
          </div>
          <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700"
                >Ride Search Radius (in kilometers)</span
              >
              <input
                v-model="settings.searchRadius"
                class="form-input block w-full"
                placeholder="30"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">
                Rent Search Radius (in kilometers)
              </span>
              <input
                v-model="settings.rentSearchRadius"
                class="form-input block w-full"
                placeholder="4"
              />
            </label>
          </div>
          <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">
                Scheduled Ride Search Radius (in kilometers)
              </span>
              <input
                v-model="settings.scheduleSearchRadius"
                class="form-input block w-full"
                placeholder="4"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700"> Number of Drivers For Bid </span>
              <input
                v-model="settings.bidDriversPerRequest"
                class="form-input block w-full"
                placeholder="4"
              />
            </label>
          </div>
          <!-- <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">
                Medium Worker Average Trip (per day)
              </span>
              <input
                v-model="settings.mediumWorkerAverageTrip"
                class="form-input block w-full"
                placeholder="4"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">
                Hard Worker Average Trip (per day)
              </span>
              <input
                v-model="settings.hardWorkerAverageTrip"
                class="form-input block w-full"
                placeholder="4"
              />
            </label>
          </div> -->
        </div>
      </div>
      <div class="flex mt-4 pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            Ride Settings
          </h3>
          <p class="text-gray-600">Set the settings related to rides/trips</p>
        </div>
        <div class="w-2/3">
          <div class="flex">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Cancel Cost</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  ETB
                </span>
                <input
                  v-model="settings.cancelCost"
                  class="form-input block w-full rounded-l-none"
                  placeholder="20"
                />
              </div>
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Discount</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  ETB
                </span>
                <input
                  v-model="settings.discount"
                  class="form-input block w-full rounded-l-none"
                  placeholder="20"
                />
              </div>
            </label>
          </div>
          <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Tax</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  %
                </span>
                <input
                  v-model="settings.tax"
                  class="form-input block w-full rounded-l-none"
                  placeholder="20"
                />
              </div>
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">SOS Timeout (In Days)</span>
              <input
                v-model="settings.sosDayLimit"
                class="form-input block w-full rounded-l-none"
                placeholder="20"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="flex mt-4 pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            Badge Settings
          </h3>
          <p class="text-gray-600">Set the settings related to Badge</p>
        </div>
        <div class="w-2/3">
          <div class="flex">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Platinum</span>
              <div class="flex">
                <input
                  v-model="settings.platinum"
                  class="form-input block w-full rounded-l-none"
                  placeholder="40"
                />
              </div>
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Gold</span>
              <div class="flex">
                <input
                  v-model="settings.gold"
                  class="form-input block w-full rounded-l-none"
                  placeholder="30"
                />
              </div>
            </label>
          </div>
          <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Silver</span>
              <div class="flex">
                <input
                  v-model="settings.silver"
                  class="form-input block w-full rounded-l-none"
                  placeholder="20"
                />
              </div>
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Bronze</span>
              <div class="flex">
                <input
                  v-model="settings.bronze"
                  class="form-input block w-full rounded-l-none"
                  placeholder="10"
                />
              </div>
            </label>
          </div>
          <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Guest</span>
              <div class="flex">
                <input
                  v-model="settings.guest"
                  class="form-input block w-full rounded-l-none"
                  placeholder="0"
                />
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="flex mt-4 pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            Social Media Settings
          </h3>
          <p class="text-gray-600">Set the settings related social medias</p>
        </div>
        <div class="w-2/3">
          <div class="flex">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Facebook Link</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  <i class="material-icons">facebook</i>
                </span>
                <input
                  v-model="settings.facebookLink"
                  class="form-input block w-full rounded-l-none"
                  placeholder="https://facebook.com/my-company"
                />
              </div>
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Twitter Link</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  <svg
                    class="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M17.3 6.2v.5c0 5-3.8 10.7-10.7 10.7-2.1 0-4.1-.6-5.8-1.7.3 0 .6.1.9.1 1.8 0 3.4-.6 4.7-1.6-1.7 0-3-1.1-3.5-2.6.2 0 .5.1.7.1.3 0 .7 0 1-.1-1.8-.4-3.1-1.9-3.1-3.8.5.3 1.1.5 1.7.5-1-.7-1.7-1.8-1.7-3.1 0-.7.2-1.3.5-1.9C3.9 5.5 6.7 7 9.9 7.2c-.1-.3-.1-.6-.1-.9 0-2.1 1.7-3.8 3.8-3.8 1.1 0 2.1.5 2.8 1.2.9-.2 1.7-.5 2.4-.9-.3.9-.9 1.6-1.7 2.1.8-.1 1.5-.3 2.2-.6-.6.8-1.2 1.4-2 1.9z"
                    />
                  </svg>
                </span>
                <input
                  v-model="settings.twitterLink"
                  class="form-input block w-full rounded-l-none"
                  placeholder="https://twitter.com/@myCompany"
                />
              </div>
            </label>
          </div>
          <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Google Link</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  <svg
                    class="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M2 5.6c0 1.5.5 2.6 1.5 3.2.8.5 1.7.6 2.2.6H6s-.2 1 .6 2h-.1c-1.3 0-5.5.3-5.5 3.7 0 3.5 3.9 3.7 4.6 3.7H5.9c.5 0 1.8-.1 3-.6 1.5-.7 2.3-2.1 2.3-3.9 0-1.8-1.2-2.8-2.1-3.6-.5-.5-1-.9-1-1.3s.3-.7.8-1.1c.7-.6 1.3-1.5 1.3-3.1 0-1.5-.2-2.4-1.4-3.1.1-.1.6-.1.8-.1.6-.1 1.6-.2 1.6-.7v-.1H6.6S2 1.4 2 5.6zm7.4 9c.1 1.4-1.1 2.4-2.9 2.6-1.8.1-3.3-.7-3.4-2.1 0-.7.3-1.3.8-1.9.6-.5 1.4-.9 2.3-.9h.3c1.7 0 2.8 1 2.9 2.3zm-1.2-10c.5 1.6-.2 3.2-1.3 3.6h-.4c-1 0-2-1-2.3-2.4-.2-.7-.2-1.4 0-2.1.2-.6.6-1.1 1.2-1.2.1 0 .3-.1.4-.1 1.2 0 1.9.5 2.4 2.2zM16 8V5h-2v3h-3v2h3v3h2v-3h3V8h-3z"
                    />
                  </svg>
                </span>
                <input
                  v-model="settings.googleLink"
                  class="form-input block w-full rounded-l-none"
                  placeholder="httsp://plus.google.com/my-company"
                />
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="flex mt-4 pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            Company Settings
          </h3>
          <p class="text-gray-600">Set the settings related to the company</p>
        </div>
        <div class="w-2/3">
          <div class="flex">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Contact Number</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  <i class="material-icons">call</i>
                </span>
                <input
                  v-model="settings.contactNumber"
                  class="form-input block w-full rounded-l-none"
                  placeholder="+251 999 999999"
                />
              </div>
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Contact Email</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  <i class="material-icons">email</i>
                </span>
                <input
                  v-model="settings.contactEmail"
                  class="form-input block w-full rounded-l-none"
                  placeholder="company@domain.com"
                />
              </div>
            </label>
          </div>
          <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Credit Allowance</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  <i class="material-icons">attach_money</i>
                </span>
                <input
                  v-model="settings.creditAllowance"
                  class="form-input block w-full rounded-l-none"
                  placeholder="4000"
                />
              </div>
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Map Key</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  <i class="material-icons">vpn_key</i>
                </span>
                <input
                  v-model="settings.mapKey"
                  class="form-input block w-full rounded-l-none"
                  placeholder="4000"
                />
              </div>
            </label>
          </div>
          <div class="flex mt-4">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Logo Image</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  <i class="material-icons">photo</i>
                </span>
                <input
                  v-model="settings.logo"
                  class="form-input block w-full rounded-l-none"
                  placeholder="Image"
                />
              </div>
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Fav Icon</span>
              <div class="flex">
                <span
                  class="flex items-center px-4 border-l border-t border-b rounded-l bg-gray-200"
                >
                  <i class="material-icons">photo</i>
                </span>
                <input
                  v-model="settings.favIcon"
                  class="form-input block w-full rounded-l-none"
                  placeholder="Fav Icon"
                />
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="flex mt-4 pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            App Version Settings
          </h3>
          <p class="text-gray-600">Set the settings related app version</p>
        </div>
        <div class="w-2/3">
          <div class="flex mb-5">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Latest Driver Android Version</span>
              <input
                v-model="settings.androidDriverVersion"
                class="form-input block w-full rounded-l-none"
                placeholder="0.0.1"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700"
                >Least Supported Driver Android Version</span
              >
              <input
                v-model="settings.leastAndroidDriverVersion"
                class="form-input block w-full rounded-l-none"
                placeholder="0.0.1"
              />
            </label>
          </div>
          <div class="flex mb-5">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Latest Driver IOS Version</span>
              <input
                v-model="settings.iosDriverVersion"
                class="form-input block w-full rounded-l-none"
                placeholder="0.0.1"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700"
                >Least Supported Driver IOS Version</span
              >
              <input
                v-model="settings.leastIosDriverVersion"
                class="form-input block w-full rounded-l-none"
                placeholder="0.0.1"
              />
            </label>
          </div>
          <div class="flex mb-5">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Driver Appstore link</span>
              <input
                v-model="settings.driverAppstoreLink"
                class="form-input block w-full rounded-l-none"
                placeholder="https://www.apple.com/app-store/"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Driver Playstore link</span>
              <input
                v-model="settings.driverPlaystoreLink"
                class="form-input block w-full rounded-l-none"
                placeholder="https://play.google.com/store"
              />
            </label>
          </div>
          <hr />
          <div class="flex mb-5 mt-3">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700"
                >Latest Passenger Android Version</span
              >
              <input
                v-model="settings.androidPassengerVersion"
                class="form-input block w-full rounded-l-none"
                placeholder="0.0.1"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700"
                >Least Supported Passenger Android Version</span
              >
              <input
                v-model="settings.leastAndroidPassengerVersion"
                class="form-input block w-full rounded-l-none"
                placeholder="0.0.1"
              />
            </label>
          </div>
          <div class="flex mb-5">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Latest Passenger IOS Version</span>
              <input
                v-model="settings.iosPassengerVersion"
                class="form-input block w-full rounded-l-none"
                placeholder="0.0.1"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700"
                >Least Supported Passenger IOS Version</span
              >
              <input
                v-model="settings.leastIosPassengerVersion"
                class="form-input block w-full rounded-l-none"
                placeholder="0.0.1"
              />
            </label>
          </div>
          <div class="flex mb-5">
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Passenger Appstore link</span>
              <input
                v-model="settings.passengerAppstoreLink"
                class="form-input block w-full rounded-l-none"
                placeholder="https://www.apple.com/app-store/"
              />
            </label>
            <label class="block px-2 w-1/2">
              <span class="text-gray-700">Passenger Playstore link</span>
              <input
                v-model="settings.passengerPlaystoreLink"
                class="form-input block w-full rounded-l-none"
                placeholder="https://play.google.com/store"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="flex mt-4 pt-4">
        <div class="w-1/3"></div>
        <div class="w-2/3">
          <button
            class="px-24 py-2 text-white font-bold rounded shadow"
            :disabled="busy"
            :class="
              busy
                ? 'bg-ilift-300 cursor-not-allowed'
                : 'bg-ilift-700 hover:bg-ilift-800 hover:shadow-none'
            "
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      settings: {},
      busy: false,
    };
  },
  created() {
    this.$http
      .get("/setting")
      .then((response) => (this.settings = response.data))
      .catch((err) => console.log(err));
  },
  methods: {
    update() {
      this.busy = true;
      this.$http
        .post("/setting", { ...this.settings })
        .then(() => {
          window.flash({ type: "success", body: "Updated Successfully!" });
        })
        .catch((err) => {
          window.flash({ type: "error", body: "Failed to save settings!" });
          console.log(err);
        })
        .finally(() => (this.busy = false));
    },
  },
};
</script>
